import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { TopHeader } from "@/components/TopHeader";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex h-screen w-full flex-col">
      {/* Top bar - spans full width, height controlled by CSS variable --admin-top-bar-height, sticky */}
      <div className="flex-shrink-0 w-full z-20 sticky top-0" style={{ height: 'var(--admin-top-bar-height)' }}>
        <TopHeader />
      </div>

      {/* Content area - sidebar + main content, wrapped in SidebarProvider */}
      <SidebarProvider>
        <div className="admin-layout-content flex flex-1 overflow-hidden relative">
          <AppSidebar />
          <main className="flex-1 overflow-hidden flex flex-col p-10">
            {children}
          </main>
        </div>
      </SidebarProvider>
    </div>
  );
}

